<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.evaluacion' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  />
  <app-filters filtros
    [name]="'filtros.sucursales' | translate"
    [array]="sucursales"
    [typeFilter]="Filters.SUCURSALES"
    [consolidado]="sucursalConsolidado"
    (eventClick)="sucursalChange($event)"
    [click]="false"
  />
  <div filtros [class.filtroDeshabilitado]="perspectivaActiva"
    [matTooltip]="perspectivaActiva ? ('cues.resultados-clima.graficas-dim-bloqueada' | translate) : ''">
    <app-filters
      [name]="'filtros.dimensiones' | translate"
      [array]="dimensiones"
      [typeFilter]="Filters.SUCURSALES"
      [consolidado]="dimensionConsolidado"
      (eventClick)="dimensionChange($event)"
      [click]="false"
    />
  </div>

  <div borrador>
    <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>

  <div contenido class="spacePrincipal" [class.vistaDim]="vistaDimension">
    @if (loadingResultados) {
      <div class="spinner-overlay">
        <div class="spinner-css"></div>
      </div>
    }
    <div class="leftSide">
      <div class="topZone w3-white">
        <div class="encabezadoZonas">
          <div class="titulo">
            {{cuestionario_name}} |
            {{ segmentoSeleccion }}{{ periodoTitulo ? ' · ' + periodoTitulo : '' }}
          </div>
          <div class="menu">
            <mat-icon class="iconoMen" [class.iconoInactivo]="!mostrarLineaZona1" (click)="toggleLineaZona(1)" [matTooltip]="'cues.resultados-clima.tooltip-promedio' | translate">horizontal_rule</mat-icon>
            <mat-icon class="iconoMen" (click)="etiquetasZona1 = !etiquetasZona1" [matTooltip]="'cues.resultados-clima.tooltip-etiquetas' | translate">{{ etiquetasZona1 ? 'label_off' : 'label' }}</mat-icon>
            <mat-icon class="iconoMen" (click)="ampliarGraficas(1)">zoom_out_map</mat-icon>
            <mat-icon class="iconoMen" [matMenuTriggerFor]="menuZona1">more_vert</mat-icon>
            <mat-menu #menuZona1="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="perspectivasZona1" [disabled]="vistaDimension"
                [matTooltip]="vistaDimension ? ('cues.resultados-clima.graficas-dim-bloqueada' | translate) : ''">
                <mat-icon class="iconoGris">account_tree</mat-icon>
                <span>{{'cues.resultados-clima.menu-perspectiva' | translate}}</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="tiposZona1" [disabled]="vistaDimension"
                [matTooltip]="vistaDimension ? ('cues.resultados-clima.graficas-dim-bloqueada' | translate) : ''">
                <mat-icon class="iconoGris">assessment</mat-icon>
                <span>{{'cues.resultados-clima.menu-graficas' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="exportarZona(1)">
                <mat-icon class="iconoGris">image</mat-icon>
                <span>{{'cues.resultados-clima.menu-exportar' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #tiposZona1="matMenu">
              <button mat-menu-item (click)="cambiarTipoGrafica(1, typesGraf.BAR)"
                [disabled]="type === typesGraf.BAR">
                <mat-icon class="iconoGris">bar_chart</mat-icon><span>{{'cues.resultados-clima.grafica-barras' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(1, typesGraf.LINE)"
                [disabled]="type === typesGraf.LINE">
                <mat-icon class="iconoGris">show_chart</mat-icon><span>{{'cues.resultados-clima.grafica-linea' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(1, typesGraf.AREA)"
                [disabled]="type === typesGraf.AREA">
                <mat-icon class="iconoGris">area_chart</mat-icon><span>{{'cues.resultados-clima.grafica-area' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #perspectivasZona1="matMenu">
              @for (p of perspectivas; track p.key) {
                <button mat-menu-item (click)="cambiarPerspectiva(p.key)" [disabled]="perspectivaSel === p.key">
                  <span>{{ p.name }}</span>
                </button>
              }
            </mat-menu>
          </div>
        </div>
        <div class="bodyZonas" [class.espacioEjeHorizontal]="type === typesGraf.BARHORIZONTAL">
          @if (loadingResultados) {
            <app-skeleton-grafica [barras]="labels.length || 6" [leyendas]="1" />
          } @else {
            <app-graficador
              #graficador1
              [data]="data"
              [labels]="labels"
              [type]="type"
              [colors]="colores"
              [axisX]="''"
              [axisY]="type === typesGraf.BARHORIZONTAL ? [''] : [('cues.resultados-clima.eje-ponderacion' | translate)]"
              [zona]="1"
              [etiquetas]="etiquetasZona1"
              [formatEtiquetas]="true"
              [distributed]="!perspectivaActiva"
              [legend]="perspectivaActiva ? {enabled: true, position: 'bottom'} : {enabled: false, position: 'right'}"
              [lineaReferencia]="mostrarLineaZona1 && !perspectivaActiva ? lineaRefZona1 : null"
              [lineaReferenciaLabel]="lineaRefLabelZona1"
              (eventClick)="barraClick($event)"
            />
          }
        </div>
      </div>
      <div class="bottomZone w3-white">
        <div class="encabezadoZonas">
          <div class="titulo">
            {{cuestionario_name}} |
            {{ segmentoSeleccion }}{{ periodoTitulo ? ' · ' + periodoTitulo : '' }}
          </div>
          <div class="menu">
            <mat-icon class="iconoMen" [class.iconoInactivo]="!mostrarLineaZona2" (click)="toggleLineaZona(2)" [matTooltip]="'cues.resultados-clima.tooltip-promedio' | translate">horizontal_rule</mat-icon>
            <mat-icon class="iconoMen" (click)="etiquetasZona2 = !etiquetasZona2" [matTooltip]="'cues.resultados-clima.tooltip-etiquetas' | translate">{{ etiquetasZona2 ? 'label_off' : 'label' }}</mat-icon>
            <mat-icon class="iconoMen" (click)="ampliarGraficas(2)">zoom_out_map</mat-icon>
            <mat-icon class="iconoMen" [matMenuTriggerFor]="menuZona2">more_vert</mat-icon>
            <mat-menu #menuZona2="matMenu">
              <button mat-menu-item [matMenuTriggerFor]="tiposZona2">
                <mat-icon class="iconoGris">assessment</mat-icon>
                <span>{{'cues.resultados-clima.menu-graficas' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="exportarZona(2)">
                <mat-icon class="iconoGris">image</mat-icon>
                <span>{{'cues.resultados-clima.menu-exportar' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #tiposZona2="matMenu">
              <button mat-menu-item (click)="cambiarTipoGrafica(2, typesGraf.BAR)"
                [disabled]="type2 === typesGraf.BAR">
                <mat-icon class="iconoGris">bar_chart</mat-icon><span>{{'cues.resultados-clima.grafica-barras' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(2, typesGraf.LINE)"
                [disabled]="type2 === typesGraf.LINE">
                <mat-icon class="iconoGris">show_chart</mat-icon><span>{{'cues.resultados-clima.grafica-linea' | translate}}</span>
              </button>
              <button mat-menu-item (click)="cambiarTipoGrafica(2, typesGraf.AREA)"
                [disabled]="type2 === typesGraf.AREA">
                <mat-icon class="iconoGris">area_chart</mat-icon><span>{{'cues.resultados-clima.grafica-area' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="bodyZonas">
          @if (loadingResultados) {
            <app-skeleton-grafica [barras]="labels2.length || 5" [leyendas]="1" />
          } @else {
            <app-graficador
              #graficador2
              [data]="data2"
              [labels]="labels2"
              [type]="type2"
              [colors]="colores2"
              [axisX]="''"
              [axisY]="[('cues.resultados-clima.eje-ponderacion' | translate)]"
              [zona]="2"
              [etiquetas]="etiquetasZona2"
              [formatEtiquetas]="true"
              [distributed]="true"
              [lineaReferencia]="mostrarLineaZona2 ? lineaRefZona2 : null"
              [lineaReferenciaLabel]="lineaRefLabelZona2"
              (eventClick)="sucursalBarraClick($event)"
            />
          }
        </div>
      </div>
    </div>
    <div class="rightSide">
        @if (!loadingResultados && !vistaDimension) {
          <div class="encabezadoTarjetas">{{ tituloTarjetas }}</div>
        }
        <app-scroll-container class="scrollTarjetas" orientation="vertical">
        <div class="bodyZonass containerTarjetas" [class.unaColumna]="vistaDimension">
          @if (loadingResultados) {
            <app-skeleton-card />
            <app-skeleton-card />
            <app-skeleton-card />
            <app-skeleton-card />
          } @else if (vistaDimension) {
            <!-- Universo: encuestas enviadas del periodo (fallback: respuestas) -->
            <app-tarjetas
              [header]="'Universo'"
              [valueStr]="vistaDimension.universo + ''"
              [footer]="'colaboradores'"
              [icon]="''"
              [color]="'black'"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
              [siceFooter]="'1.1rem'"
            />

            <!-- Muestra: encuestados de la sucursal (o total de respuestas en consolidado) -->
            <app-tarjetas
              [header]="'Muestra'"
              [valueStr]="vistaDimension.muestra + ''"
              [footer]="vistaDimension.sucLabel + ' | ' + vistaDimension.muestraPct + '%'"
              [icon]="''"
              [color]="'black'"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
              [siceFooter]="'1.1rem'"
            />

            <!-- Score de la dimensión con el alcance de Sucursal -->
            <app-tarjetas
              [header]="vistaDimension.dimension"
              [valueStr]="(vistaDimension.score ?? '—') + ''"
              [footer]="vistaDimension.sucLabel"
              [icon]="''"
              [color]="'black'"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
              [siceFooter]="'1.1rem'"
            />

            <!-- Promedio global de la dimensión: actual vs evaluación anterior -->
            <!-- [color]="vistaDimension.tendencia === 'up' ? '#72D54A' : vistaDimension.tendencia === 'down' ? '#FF495C' : '#1976d2'" -->
            <app-tarjetas
              [header]="'Promedio'"
              [valueStr]="(vistaDimension.actual ?? '—') + ''"
              [footer]="vistaDimension.anterior != null
                ? (vistaDimension.anioActual + ' vs ' + vistaDimension.anioAnterior + ': ' + vistaDimension.anterior)
                : (vistaDimension.anioActual + ' · 1ª eval')"
              [icon]="vistaDimension.tendencia === 'up' ? 'arrow_drop_up' : vistaDimension.tendencia === 'down' ? 'arrow_drop_down' : 'remove'"
              [color]="'black'"
              [iconFirst]="false"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
              [siceFooter]="'1.1rem'"
            />
          } @else {
          @for (element of categoriasVista; track $index) {
            <app-tarjetas
              [header]="element.name"
              [valueStr]="(element.ponderacion ?? '—') + ''"
              [footer]="''"
              [icon]="iconoDimension(element.name)"
              [color]="'black'"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
              [barColor]="colorSemaforo(element.ponderacion)"
              [barPercent]="(element.ponderacion ?? 0) / maximoPonderacion * 100"
            />
          }

          <!-- Cards de comparación: actual vs evaluación anterior -->
          <!-- [color]="comparativo.actual.tendencia === 'up' ? '#72D54A' : comparativo.actual.tendencia === 'down' ? '#FF495C' : '#1976d2'" */ -->
          @if (comparativo) {
            <app-tarjetas
              [header]="comparativo.actual.label"
              [valueStr]="(comparativo.actual.score ?? '—') + ''"
              [footer]="''"
              [icon]="comparativo.actual.tendencia === 'up' ? 'arrow_drop_up' : comparativo.actual.tendencia === 'down' ? 'arrow_drop_down' : 'remove'"
              [color]="'black'"
              [iconFirst]="false"
              [siceHeader]="'1.5rem'"
              [siceValue]="'2.2rem'"
            />

            @if (comparativo.anterior) {
              <app-tarjetas
                [header]="comparativo.anterior.label"
                [valueStr]="(comparativo.anterior.score ?? '—') + ''"
                [footer]="''"
                [icon]="''"
                [color]="'black'"
                [siceHeader]="'1.5rem'"
                [siceValue]="'2.2rem'"
              />
            } @else {
              <app-tarjetas
                [header]="'Primera evaluación'"
                [valueStr]="'—'"
                [footer]="''"
                [icon]="''"
                color]="'black'"
                [siceHeader]="'1.5rem'"
                [siceValue]="'2.2rem'"
              />
            }
          }
          }
        </div>
        </app-scroll-container>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="ampliar" [export]="true" [iconoExport]="'image'" (exportFile)="exportarGrafica1()" (close)="cerrarGraficas()">
  <div modal-header>

  </div>
  <div modal-body>
    <div class="spaceGrafica">
        @if (ampliarGrafica1) {
          <div class="contenedorGrafica" [class.espacioEjeHorizontal]="type === typesGraf.BARHORIZONTAL">
            <app-graficador
              [data]="data"
              [labels]="labels"
              [type]="type"
              [colors]="colores"
              [axisX]="''"
              [axisY]="type === typesGraf.BARHORIZONTAL ? [''] : [('cues.resultados-clima.eje-ponderacion' | translate)]"
              [zona]="11"
              [etiquetas]="etiquetasZona1"
              [formatEtiquetas]="true"
              [distributed]="!perspectivaActiva"
              [legend]="perspectivaActiva ? {enabled: true, position: 'bottom'} : {enabled: false, position: 'right'}"
              [lineaReferencia]="mostrarLineaZona1 && !perspectivaActiva ? lineaRefZona1 : null"
              [lineaReferenciaLabel]="lineaRefLabelZona1"
            />
          </div>
        }@else if (ampliarGrafica2) {
          <div class="contenedorGrafica">
            <app-graficador
              [data]="data2"
              [labels]="labels2"
              [type]="type2"
              [colors]="colores2"
              [axisX]="''"
              [axisY]="[('cues.resultados-clima.eje-ponderacion' | translate)]"
              [zona]="21"
              [etiquetas]="etiquetasZona2"
              [formatEtiquetas]="true"
              [distributed]="true"
              [lineaReferencia]="mostrarLineaZona2 ? lineaRefZona2 : null"
              [lineaReferenciaLabel]="lineaRefLabelZona2"
              (eventClick)="sucursalBarraClick($event)"
            />
          </div>
        }
    </div>
  </div>
</app-modal>